import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/ip',
    name: 'Ip',
    component: () => import(/* webpackChunkName: "about" */ '../components/ip/index.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../components/about/index.vue')
  },
  {
    path: '/channels',
    name: 'Channels',
    component: () => import(/* webpackChunkName: "about" */ '../components/channels/index.vue')
  },
  {
    path: '/store',
    name: 'Store',
    component: () => import(/* webpackChunkName: "about" */ '../components/store/index.vue')
  },
  {
    path: '/market',
    name: 'Market',
    component: () => import(/* webpackChunkName: "about" */ '../components/market/index.vue')
  },
  {
    path: '/marketDetail',
    name: 'MarketDetail',
    component: () => import(/* webpackChunkName: "about" */ '../components/market/marketDetail.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "about" */ '../components/news/index.vue')
  },
  {
    path: '/newsDetail',
    name: 'NewsDetail',
    component: () => import(/* webpackChunkName: "about" */ '../components/news/newsDetail.vue')
  },
  {
    path: '/vocationalWork',
    name: 'VocationalWork',
    component: () => import(/* webpackChunkName: "about" */ '../components/vocationalWork/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
